import { AsyncInteractionViewModel } from "./AsyncInteractionViewModel";

export class SimpleAsyncInteractionViewModel extends AsyncInteractionViewModel {
    public headerText: string | null = null;
    public text: string | null = null;
    public subtitle: string | null = null;
}
